import { Button, Grid, TextField } from '@material-ui/core';
import { ChevronLeft, GetApp } from '@material-ui/icons';
import { useStyles } from '@webapps/styles';
import ActionClasse from '../../Classes/Components/ActionsClasse';

const ClassesDetailFilter = ({ children, goToPreviousPage, searchKeyword, idParam, totalElements, isSameDay, date, setIsQRCodeModalOpen, setIsExportStatementsModalOpen, page }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);



  return (
    <Grid container>
      <Grid item xs={12}>
        <div className={classes.containerSearch}>
          <div
            className={css({
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              '@media (max-width:880px)': {
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: '10px',
              },
              '@media (max-width:768px)': {
                // justifyContent: 'flex-end' 
              },
            })}
          >
            {/* <Grid container spacing={2} xs={12} md={11} style={{ margin: 0, gap: '10px' }}>
  <Grid xs={12} sm={1}> */}
            <div className={classes.leftFilterContainer}>


              <div className={css({
                display: 'flex',
                gap: '10px',

              })}>

                <Button
                  className={classes.returnButton}
                  onClick={goToPreviousPage}
                  startIcon={<ChevronLeft />}
                >
                  Retour aux classes
                </Button>
                <ActionClasse
                  from="item"
                  id={idParam}
                  nbrStudent={totalElements}
                  refetch={() => { }}
                  className={css({
                    display: 'none',
                    '@media (max-width:880px)': {
                      display: 'flex',
                    },
                  })}
                />
              </div>
              <div
                className={classes.leftFilterInput}
              >
                <TextField
                  fullWidth
                  label="Nom et prénom"
                  onChange={(e) => searchKeyword(e)}
                  size="small"
                  variant="outlined"
                  borderRadius={30}

                />
              </div>


            </div>
            <div className={classes.rightFilterContainer}>
              <div style={{ display: "flex" }}
                className={
                  css({
                    gap: "16px",
                    '@media (max-width:880px)': {
                      flexDirection: 'column',
                      gap: '10px',
                      width: '100%',

                      '& button': {
                        width: '100%',
                        maxWidth: '100%',
                      },
                    },
                    '@media (max-width:768px)': {
                      flexDirection: 'column',
                    },
                  })
                }
              >
                <Button
                  className={[classes.emergenceButton, css({
                    '@media only screen and (max-width:1920px)': { fontSize: '15.00px' },
                    '@media only screen and (max-width:1600px)': { fontSize: '14.00px' },
                    '@media only screen and (max-width:768px)': {
                      flexGrow: 1,
                    },
                  })
                  ]}
                  color="primary"
                  disabled={!isSameDay(new Date(), new Date(date))}
                  onClick={() => setIsQRCodeModalOpen(true)}
                  variant="contained"
                  disableElevation
                  style={{
                    fontWeight: 600,
                  }}
                >
                  Émargement
                </Button>
                <Button
                  className={[classes.button, css({
                    '@media only screen and (max-width:1920px)': { fontSize: '15.00px' },
                    '@media only screen and (max-width:1600px)': { fontSize: '14.00px' },
                    '@media only screen and (max-width:768px)': {
                      flexGrow: 1,
                    },
                  })
                  ]}
                  color="primary"
                  onClick={() => setIsExportStatementsModalOpen(true)}
                  variant="outlined"
                  disableElevation
                  style={{
                    border: '1px solid #0060F9',
                    fontWeight: 600,
                    backgroundColor: 'white',
                  }}
                >
                  <GetApp />&nbsp;Exporter
                </Button>
              </div>
              <ActionClasse
                from="item"
                id={idParam}
                nbrStudent={totalElements}
                refetch={() => { }}
                className={css({
                  '@media (max-width:880px)': {
                    display: 'none',
                  },
                })}
              />
            </div>

          </div>

        </div>
        <Grid
          container
          style={{
            backgroundColor: '#F3F7FF',
            borderRadius: 10,
            padding: spacing(0, 0, 2.5, 2.5),
            marginBottom: page > 1 ? spacing(2.5) : spacing(0),
          }}
        >
          {children}
        </Grid>
      </Grid>
    </Grid>
  );
};

const styles = ({ spacing }) => ({
  containerSearch: {
    background: 'white',
    paddingBottom: spacing(2.5),
    borderRadius: 10,
    '@media only screen and (max-width:768px)': {
      // marginTop: spacing(3),
      // paddingTop: spacing(2.5),
    },
  },
  leftFilterContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',

    '@media (max-width:880px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      width: '100%',

      '& button': {
        width: '100%',
        maxWidth: '100%',
      },

      "& div": {
        width: '100%',
      },
    },
  },
  leftFilterInput: {
    width: '100%',
    minWidth: '200px',
    width: '20vw',
    // backgroundColor: 'red !important',
  },
  rightFilterContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    '@media (max-width:880px)': {
      gap: '10px !important',
      flexDirection: 'column',
      alignItems: 'flex-start',
      width: '100%',
    },
  },
  returnButton: {
    color: '#5A6DA1',
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    border: '1px solid #C0D9FF',
    backgroundColor: 'white',
    borderRadius: '20px',
    width: '100%',
    fontWeight: 600,
    maxWidth: '200px',

    '@media (max-width:880px)': {
      flexShrink: 0,
      width: 'calc(100% - 40px) !important',
      maxWidth: 'calc(100% - 40px) !important',
    }
  },
  emergenceButton: {
    height: '42px',
    backgroundColor: '#C0D9FF',
    color: '#0060F9',
    border: '1px solid transparent',
    transition: 'none',
    '&:hover': {
      border: '1px solid #0060F9',
      // filter: 'brightness(0.9)',
      backgroundColor: '#C0D9FF',
    },
  },
  button: {
    height: '42px',
  },
});

export default ClassesDetailFilter;